// extracted by mini-css-extract-plugin
var _1 = "Empty_absolute__ad226";
var _2 = "Empty_grow__73b8f";
var _3 = "Empty_hint__16329";
var _4 = "Empty_large__2c93d";
var _5 = "Empty_medium__0059a";
var _6 = "Empty_mini__c81e0";
var _7 = "Empty_root__0a7b2";
var _8 = "Empty_xmini__f6dae";
export { _1 as "absolute", _2 as "grow", _3 as "hint", _4 as "large", _5 as "medium", _6 as "mini", _7 as "root", _8 as "xmini" }
